<template lang="pug">
  .login-form
    Authenticate(:registration="registration" :signin-button-text="signinButtonText" @success="redirect")
</template>

<script>
import router from '@/router';
import Authenticate from '@/extensions/restricted-area/components/Authenticate';

export default {
    name: 'LoginForm',
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    components: {
        Authenticate
    },
    computed: {
        registration() {
            // default value
            let registration = false;

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'registration');
                if (setting && setting.value === 'allow') registration = true;
                else if (setting && setting.value === 'forbid') registration = false;
            }

            return registration;
        },
        hyperlink() {
            const content = this.section.contents.find(content => content.key === 'form');
            if (content) return content.hyperlink;
            return false;
        },
        signinButtonText() {
            let text = 'Anmelden';
            if (this.hyperlink && this.hyperlink.name) text = this.hyperlink.name;
            return text;
        }
    },
    methods: {
        redirect() {
            if (this.hyperlink && this.hyperlink.menuItem) {
                router.push(this.hyperlink.menuItem.path);
            } else {
                // redirect to the last route in history
                router.go(-1);
            }
        }
    }
};
</script>

<style lang="sass" scoped></style>
